module.exports = __webpack_public_path__ + "profile-icon.svg";